import { render, staticRenderFns } from "./contractDetailFee.vue?vue&type=template&id=f0407048&scoped=true"
import script from "./contractDetailFee.vue?vue&type=script&lang=js"
export * from "./contractDetailFee.vue?vue&type=script&lang=js"
import style0 from "./contractDetailFee.vue?vue&type=style&index=0&id=f0407048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0407048",
  null
  
)

export default component.exports